// 입금 RPC 에러 분류(순수 함수, 의존성 없음). hook과 component가 함께 쓰므로 service가 아닌 leaf util로 둔다
// (component→service 경계 위반 회피 — codexloop 제외 R4). types/deposit과 같은 도메인 leaf 취급.

// link/confirm/undo RPC는 stale(로드 후 다른 탭이 입금을 변경, restored 버전누락, 주문 금융 지문
// 불일치) 시 ERRCODE 'P0003'으로 RAISE한다. 호출측이 '재시도해도 똑같이 실패하는 stale'과
// '일시 오류'를 구분해 새로고침을 유도하도록 판별.
// ★40001 금지 이유(2026-07-06 실측): serialization_failure는 PostgREST가 자동 재시도해
//   영구 stale 조건에서 초당 ~1,600회 무한루프 후 504 — v4 마이그레이션에서 전부 P0003으로 교체.
//   '40001' 매칭은 구 RPC 잔재 호환용으로 유지.
export function isStaleDepositError(err: unknown): boolean {
  const e = err as { code?: string; message?: string } | null;
  return !!e && (e.code === 'P0003' || e.code === '40001' || /changed since loaded|stale|expected version required/i.test(e.message ?? ''));
}

// confirm RPC의 완납/출고 재확정 거부(ERRCODE 'P0002' — v2에서 복원된 가드). stale과 같은
// '영구 거부' 계열(재시도 무의미 → 새로고침 유도)이지만, 원인이 달라 안내 문구를 구분한다:
// stale = "바뀌었으니 다시 확인", settled = "이미 입금/출고 처리 끝난 주문"(재확정 자체가 불가).
export function isSettledOrderDepositError(err: unknown): boolean {
  const e = err as { code?: string; message?: string } | null;
  return !!e && (e.code === 'P0002' || /already paid or shipped/i.test(e.message ?? ''));
}
